import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';

const queryClient = new QueryClient();

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '6px 8px', // Reduces standard cell padding globally (default was 16px/12px)
          fontSize: '0.8125rem', // Clean, readable slightly smaller font size for compact tables
        },
        sizeSmall: {
          padding: '4px 6px', // Extra compact padding for small size tables!
        },
        head: {
          padding: '8px 8px',
          height: '36px',
          fontWeight: 'bold',
          backgroundColor: '#ffffff',
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
